import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { DateTime } from 'luxon';

import withStyles from '@mui/styles/withStyles';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import CrmButton from './CrmButton';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import {
  createStdRequest,
  apiFetch,
  calculatePhoneNumberChange,
  sortedDropdownItemLabels,
  isFirmReferrerType,
  isProprietorshipType,
  isPractitionerType,
  convertToUserStdPhoneNumber,
  validatePhoneNumber,
} from '../utils/utils';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import KSelect from './KSelect';
import CrmTextField from './CrmTextField';
import DocsAssocGroup from '../components/DocsAssocGroup';
import { searchableContactDataBuilder } from './SearchableContactHierarchy';
import ReferralSelectionHierarchy from './ReferralSelectionHierarchy';
import IcfConsultancyModal from '../components/IcfConsultancyModal';
import IcfReferrerFirmModal from '../components/IcfReferrerFirmModal';
import IcfPractitionerModal from '../components/IcfPractitionerModal';
import IcfOrgContactModal from '../components/IcfOrgContactModal';
import IcfUnaffiliatedContactModal from '../components/IcfUnaffiliatedContactModal';

const styles = {
  phoneInput: {
    fontSize: '.92rem',
  },
  errorMessageDiv: {
    marginTop: '8px',
    color: 'red',
    fontWeight: 500,
  },
};

/*
Call this with
    <NewInquiryModal
        show={the condition under which it should show}
        closeModalFunc={a function for closing the dialog}
        callRailCallId={ID of CallRailCall or 0}
    />
*/

let temperatureOptions = null;

class NewInquiryModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
      communicationType: 'Phone Call',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      referralSourceCategory: 'Company / Organization',
      referralOrgType: '',
      referralOrgId: 0,
      referralContactId: 0,
      chosenWordOfMouthOption: '',
      chosenSocialMediaOption: '',
      chosenMediaOption: '',
      referralOptionalSpecies: '',
      campaignId: 0,
      ownerPersonId: 0,
      source: '',
      messageOrNote: '',
      temperature: 'Unknown',
      docs: [],

      shouldShowReferrerFirmModalStateVar: false,
      shouldShowProprietorshipModalStateVar: false,
      shouldShowPractitionerModalStateVar: false,
      shouldShowOrgContactModalStateVar: false,
      shouldShowUnaffilContactModalStateVar: false,
    };
  }

  callRailCallId = 0;

  componentDidMount() {
    if (!temperatureOptions) {
      temperatureOptions = sortedDropdownItemLabels('Lead Temperature');
    }
    this.setState({ ownerPersonId: DA.getLoggedInUserPersonId() });
    const { callRailCallId } = this.props;
    if (callRailCallId) {
      this.setStateFromData(callRailCallId);
    }
  }

  componentDidUpdate(prevProps) {
    const { callRailCallId } = this.props;
    if (!callRailCallId || callRailCallId === prevProps.callRailCallId) {
      return;
    }
    const note = DA.getNoteAboutCallRailCallWithId(callRailCallId);
    const noteText = note ? note.content : '';
    this.setStateFromData(callRailCallId, noteText);
  }

  setStateFromData(callRailCallId, noteText) {
    this.callRailCallId = callRailCallId;
    const callRailCall = DA.getCallRailCall(callRailCallId);
    const phoneNumber = convertToUserStdPhoneNumber(callRailCall.otherNumber);

    this.setState({
      phone: phoneNumber,
      messageOrNote: noteText ? noteText : '',
      referralSourceCategory: 'Company / Organization',
      referralOrgType: '',
      referralOrgId: 0,
      referralContactId: 0,
      temperature: 'Unknown',
    });
  }

  searchableContactData = searchableContactDataBuilder.build();

  changeFirstName(newName) {
    this.setState({ firstName: newName });
  }

  changeLastName(newName) {
    this.setState({ lastName: newName });
  }

  handleNumberChange(event) {
    const oldValue = this.state.phone;
    const newValue = event.target.value.trim();
    const phChange = calculatePhoneNumberChange(oldValue, newValue);
    if (phChange.shouldUpdate) {
      this.setState({ phone: phChange.newValue });
    }
  }

  handleReferrerOrgTypeChange(newValue) {
    this.setState(
      {
        referralOrgType: newValue,
        referralOrgId: 0,
        referralContactId: 0,
      },
      () => this.preselectSingleItemLists()
    );
  }

  preselectSingleItemLists() {
    if (isFirmReferrerType(this.state.referralOrgType)) {
      const knownFirmsOfReferrerType = this.getKnownFirmsOfReferrerType();
      if (knownFirmsOfReferrerType.length === 1) {
        const uniqueFirm = knownFirmsOfReferrerType[0];
        const uniqueId = uniqueFirm.id;
        if (!this.state.referralOrgId) {
          this.setState({ referralOrgId: uniqueId });
          const contactIds = DA.getFirmById(uniqueId).contactIds;
          if (contactIds.length === 1) {
            this.setState({ referralContactId: contactIds[0] });
          }
        }
      }
    }
  }

  getKnownFirmsOfReferrerType() {
    return this.props.knownFirms.filter((firm) => firm.firmType === this.state.referralOrgType);
  }

  getKnownPractices() {
    return this.props.knownFirms.filter((firm) => firm.firmType === 'Private Practitioner');
  }

  forceShowingOfNewReferrerCompanyModal(referralOrgType) {
    if (isProprietorshipType(referralOrgType)) {
      this.setState({ referralOrgType, shouldShowProprietorshipModalStateVar: true });
    } else if (isPractitionerType(referralOrgType)) {
      this.setState({ referralOrgType, shouldShowPractitionerModalStateVar: true });
    } else {
      this.setState({ referralOrgType, shouldShowReferrerFirmModalStateVar: true });
    }
  }

  forceShowingOfNewContactModal(referrerType, firmId) {
    if (referrerType) {
      this.forceShowingOfNewOrgContactModal(referrerType, firmId);
    } else {
      this.forceShowingOfNewUnaffilContactModal(referrerType, firmId);
    }
  }

  forceShowingOfNewOrgContactModal(referralOrgType, firmId) {
    this.setState({ referralOrgType, referralOrgId: firmId, shouldShowOrgContactModalStateVar: true });
  }

  forceShowingOfNewUnaffilContactModal(referrerType, firmId) {
    this.setState({ referrerType, referrerOrgId: firmId, shouldShowUnaffilContactModalStateVar: true });
  }

  shouldShowReferrerFirmModal() {
    return this.state.shouldShowReferrerFirmModalStateVar;
  }

  shouldShowProprietorshipModal() {
    return this.state.shouldShowProprietorshipModalStateVar;
  }

  shouldShowPractitionerModal() {
    return this.state.shouldShowPractitionerModalStateVar;
  }

  shouldShowOrgContactModal() {
    return this.state.shouldShowOrgContactModalStateVar;
  }

  shouldShowUnaffilContactModal() {
    return this.state.shouldShowUnaffilContactModalStateVar;
  }

  handleNewConsultancySuccess(visibleFirmType, visibleFirmId, contactId) {
    this.searchableContactData = searchableContactDataBuilder.build();
    this.setState({
      referralOrgType: visibleFirmType,
      referralOrgId: visibleFirmId,
      referralContactId: contactId,
      shouldShowReferrerFirmModalStateVar: false,
      shouldShowProprietorshipModalStateVar: false,
      shouldShowPractitionerModalStateVar: false,
    });
  }

  handleNewReferrerFirmSuccess(visibleFirmType, visibleFirmId, contactId) {
    this.searchableContactData = searchableContactDataBuilder.build();
    this.setState({
      referralOrgType: visibleFirmType,
      referralOrgId: visibleFirmId,
      referralContactId: contactId,
      shouldShowReferrerFirmModalStateVar: false,
      shouldShowProprietorshipModalStateVar: false,
      shouldShowPractitionerModalStateVar: false,
    });
  }

  handleNewPractitionerSuccess(visibleFirmType, visibleFirmId, contactId) {
    this.searchableContactData = searchableContactDataBuilder.build();
    this.setState({
      referralOrgType: visibleFirmType,
      referralOrgId: visibleFirmId,
      referralContactId: contactId,
      shouldShowReferrerFirmModalStateVar: false,
      shouldShowProprietorshipModalStateVar: false,
      shouldShowPractitionerModalStateVar: false,
    });
  }

  handleNewOrgContactSuccess(contactId) {
    this.searchableContactData = searchableContactDataBuilder.build();
    this.setState({ referralContactId: contactId, shouldShowOrgContactModalStateVar: false });
  }

  handleNewUnaffilContactSuccess(contactId) {
    this.searchableContactData = searchableContactDataBuilder.build();
    this.setState({ referralContactId: contactId, shouldShowUnaffilContactModalStateVar: false });
  }

  cancelReferrerFirmModal() {
    if (isFirmReferrerType(this.state.referralOrgType)) {
      const knownFirmsOfReferrerType = this.getKnownFirmsOfReferrerType();
      if (knownFirmsOfReferrerType.length === 0) {
        this.setState({ referralOrgType: '' });
      }
      this.setState({ referralOrgId: 0, shouldShowReferrerFirmModalStateVar: false });
    }
  }

  cancelPractitionerModal() {
    const knownPractices = this.getKnownPractices();
    if (knownPractices.length === 0) {
      this.setState({ referralOrgType: '' });
    }
    this.setState({ referralOrgId: 0, shouldShowPractitionerModalStateVar: false });
  }

  cancelContactModal() {
    this.setState({
      shouldShowOrgContactModalStateVar: false,
      shouldShowUnaffilContactModalStateVar: false,
      shouldAddEmergencyContact: false,
    });
  }

  clearFormAndCloseModal(closeFunc) {
    this.clearForm();
    closeFunc();
  }

  clearForm() {
    this.setState({
      errorMessage: undefined,
      communicationType: 'Phone Call',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      source: '',
      messageOrNote: '',
      docs: [],
      ownerPersonId: DA.getLoggedInUserPersonId(),
    });
  }

  clearErrorValidateAndSubmit() {
    this.setState({ errorMessage: '' }, () => this.validateAndSubmit());
  }

  validateAndSubmit() {
    const validationResult = this.validateForm();
    if (validationResult.valid) {
      this.submit();
    } else {
      this.setState({ errorMessage: validationResult.errorMessage });
    }
  }

  submit() {
    const apiStruct = this.buildApiStruct();
    const uri = `/api/inquiry`;
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      this.saveInquiryDocuments(json.inquiryId);
      ReduxLoader.updateInquiry(json);
      this.clearFormAndCloseModal(this.props.closeModalFunc);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  saveInquiryDocuments(inquiryId) {
    const files = this.state.docs;
    if (files.length > 0) {
      const uri = `/api/document/viewingFirm/${DA.getFirmId()}/inquiry/${inquiryId}`;
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData();
        formData.append('file', files[i].data);
        fetch(uri, { method: 'POST', body: formData })
          .then((response) => response.json())
          .then(async (result) => {
            if (await result) {
              const { typeTag, description } = files[i];
              if (description.trim() !== '' || (typeTag !== '' && typeTag !== 'None')) {
                this.updateDocumentRequest(typeTag, description, result.storedDocumentId);
              }
            }
          })
          .catch((error) => console.log(error));
      }
    }
  }

  updateDocumentRequest(documentType, description, documentId) {
    const uri = `/api/document/${documentId}`;
    const apiStruct = {
      typeTag: documentType === 'None' ? null : documentType,
      description: description.trim(),
    };
    const request = createStdRequest(uri, 'put', apiStruct);
    const actionOnGoodResponse = (json) => {
      console.log(json);
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  buildApiStruct() {
    const firmId = DA.getFirmId();
    const callRailCallId = this.callRailCallId;
    const {
      communicationType,
      firstName,
      lastName,
      email,
      phone,
      referralSourceCategory,
      referralOrgType,
      referralOrgId,
      referralContactId,
      chosenWordOfMouthOption,
      chosenSocialMediaOption,
      chosenMediaOption,
      referralOptionalSpecies,
      campaignId,
      ownerPersonId,
      messageOrNote,
      temperature,
      docs,
    } = this.state;
    return {
      inquiryId: 0,
      date: DateTime.local().toISO(),
      viewingFirmId: firmId,
      communicationType,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email,
      phone,
      referralSourceCategory,
      referralOrgType,
      referralOrgId,
      referralContactId,
      referralWordOfMouthType: chosenWordOfMouthOption,
      referralSocialMediaType: chosenSocialMediaOption,
      referralMediaType: chosenMediaOption,
      referralSourceSpecies: referralOptionalSpecies,
      campaignId,
      ownerPersonId,
      source: 'CrmForm',
      message: messageOrNote.trim(),
      temperature,
      extras: [],
      docs: docs,
      callRailCallId,
    };
  }

  validateForm() {
    if (!this.state.firstName.trim()) {
      return { valid: false, errorMessage: 'You must provide a First Name' };
    }
    if (!this.state.lastName.trim()) {
      return { valid: false, errorMessage: 'You must provide a Last Name' };
    }
    if (!this.state.messageOrNote.trim()) {
      return { valid: false, errorMessage: 'You must provide a Message or Note' };
    }
    if (this.state.phone) {
      const validity = validatePhoneNumber(this.state.phone);
      if (!validity.valid) {
        return validity;
      }
    }
    return { valid: true };
  }

  commTypeDropdownOptions = sortedDropdownItemLabels('Referral Communication Type');

  setReferralCategory(newCategory) {
    this.setState({ referralSourceCategory: newCategory, referralOptionalSpecies: '' });
  }

  setReferralOrgType(referralOrgType) {
    this.handleReferrerOrgTypeChange(referralOrgType);
  }

  selectCompany(referralOrgType, referralOrgId) {
    this.setState({ referralOrgType, referralOrgId });
  }

  selectContact(referralOrgType, referralOrgId, personId) {
    this.setState({ referralOrgType, referralOrgId, referralContactId: personId });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, show, closeModalFunc } = this.props;

    const users = DA.getAllFirmUsers();
    const namedOptions = users.map((u) => u.name);
    const realUserPersonIds = users.map((u) => u.personId);
    const userNameOptions = [...namedOptions, 'Unassigned'];
    const userPersonIdOptions = [...realUserPersonIds, 0];

    const campaigns = DA.getAllCampaigns();
    const sortedCampaigns = campaigns.sort((f1, f2) => {
      const f1Name = f1.name;
      const f2Name = f2.name;
      if (f1Name < f2Name) {
        return -1;
      } else if (f2Name < f1Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return (
      <div>
        <Dialog
          open={show}
          onClose={() => this.clearFormAndCloseModal(closeModalFunc)}
          fullWidth={true}
          maxWidth={'lg'}
        >
          <DialogTitle>Create New Lead</DialogTitle>

          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <KSelect
                  id="communication-type"
                  name="communicationType"
                  label="Communication Type"
                  fullWidth={true}
                  disabledOption="Choose Type"
                  liveOptions={this.commTypeDropdownOptions}
                  value={this.state.communicationType}
                  onChange={(event) => this.setState({ communicationType: event.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={6} />
              <Grid item xs={6} md={3}>
                <CrmTextField
                  label="First Name"
                  fullWidth
                  value={this.state.firstName}
                  onChange={(event) => this.changeFirstName(event.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <CrmTextField
                  label="Last Name"
                  fullWidth
                  value={this.state.lastName}
                  onChange={(event) => this.changeLastName(event.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <CrmTextField
                  label="Email"
                  fullWidth
                  value={this.state.email}
                  onChange={(event) => this.setState({ email: event.target.value.trim() })}
                />
              </Grid>
              <Grid item xs={6} md={2}>
                Phone:
                <br />
                <Input
                  className={classes.phoneInput}
                  value={this.state.phone}
                  onChange={(event) => this.handleNumberChange(event)}
                  placeholder="(213) 555-1212"
                />
              </Grid>

              <Grid className={classes.selectionHierarchy} item xs={12}>
                <ReferralSelectionHierarchy
                  searchableContactData={this.searchableContactData}
                  chosenReferralCategory={this.state.referralSourceCategory}
                  companyType={this.state.referralOrgType}
                  companyId={this.state.referralOrgId}
                  contactId={this.state.referralContactId}
                  chosenWordOfMouthOption={this.state.chosenWordOfMouthOption}
                  chosenSocialMediaOption={this.state.chosenSocialMediaOption}
                  chosenMediaOption={this.state.chosenMediaOption}
                  referralOptionalSpecies={this.state.referralOptionalSpecies}
                  onReferralCategoryChange={(referralCategory) => this.setReferralCategory(referralCategory)}
                  onCompanyTypeChange={(referralOrgType) => this.setReferralOrgType(referralOrgType)}
                  onCompanyChange={(referralOrgType, referralOrgId) =>
                    this.selectCompany(referralOrgType, referralOrgId)
                  }
                  onContactChange={(referralOrgType, referralOrgId, personId) =>
                    this.selectContact(referralOrgType, referralOrgId, personId)
                  }
                  onWordOfMouthOptionChange={(newChoice) => this.setState({ chosenWordOfMouthOption: newChoice })}
                  onSocialMediaOptionChange={(newChoice) => this.setState({ chosenSocialMediaOption: newChoice })}
                  onMediaOptionChange={(newChoice) => this.setState({ chosenMediaOption: newChoice })}
                  onOptionalSpeciesChange={(newValue) => this.setState({ referralOptionalSpecies: newValue })}
                  onCreateNewCompany={(referralOrgType) => this.forceShowingOfNewReferrerCompanyModal(referralOrgType)}
                  onCreateNewContact={(referralOrgType, firmId) =>
                    this.forceShowingOfNewContactModal(referralOrgType, firmId)
                  }
                />
              </Grid>

              <Grid style={{ margin: '0 2px 5px 2px' }} container spacing={2}>
                <Grid item xs={12} md={4}>
                  <KSelect
                    label="Owner"
                    fullWidth={true}
                    disabledOption="Select Owner"
                    liveOptions={userNameOptions}
                    liveValues={userPersonIdOptions}
                    value={this.state.ownerPersonId}
                    onChange={(event) => this.setState({ ownerPersonId: event.target.value })}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <KSelect
                    label="Temperature"
                    fullWidth={true}
                    disabledOption="Select Temperature"
                    liveOptions={temperatureOptions}
                    value={this.state.temperature}
                    onChange={(event) => this.setState({ temperature: event.target.value })}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <KSelect
                    label="Campaign"
                    fullWidth={true}
                    disabledOption='Select Campaign (or "None")'
                    liveOptions={['None'].concat(sortedCampaigns.map((c) => c.name))}
                    liveValues={[0].concat(sortedCampaigns.map((c) => c.campaignId))}
                    value={this.state.campaignId}
                    onChange={(event) => this.setState({ campaignId: event.target.value })}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <CrmTextField
                  label="Message or Note"
                  fullWidth
                  multiline
                  value={this.state.messageOrNote}
                  onChange={(event) => this.setState({ messageOrNote: event.target.value })}
                />
              </Grid>
              <Grid item xs={12}>
                <DocsAssocGroup
                  docsSubjectProvider={this}
                  allRelevantDocs={this.state.docs}
                  clientId={0}
                  inquiryId={0}
                  parent={this}
                />
              </Grid>
              <Grid item xs={12} className={classes.errorMessageDiv}>
                {this.state.errorMessage}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CrmButton outlined onClick={() => this.clearFormAndCloseModal(closeModalFunc)}>
              Cancel
            </CrmButton>
            <CrmButton filled onClick={() => this.clearErrorValidateAndSubmit()}>
              Create
            </CrmButton>
          </DialogActions>
        </Dialog>

        {this.shouldShowProprietorshipModal() && (
          <IcfConsultancyModal
            proprietorshipType={this.state.referralOrgType}
            onSuccess={(visibleFirmType, visibleFirmId, contactId) =>
              this.handleNewConsultancySuccess(visibleFirmType, visibleFirmId, contactId)
            }
            onCancel={() => this.cancelProprietorshipModal()}
          />
        )}

        {this.shouldShowReferrerFirmModal() && (
          <IcfReferrerFirmModal
            firmType={this.state.referralOrgType}
            onSuccess={(visibleFirmType, visibleFirmId, contactId) =>
              this.handleNewReferrerFirmSuccess(visibleFirmType, visibleFirmId, contactId)
            }
            onCancel={() => this.cancelReferrerFirmModal()}
          />
        )}

        {this.shouldShowPractitionerModal() && (
          <IcfPractitionerModal
            firmType={this.state.referralOrgType}
            onSuccess={(visibleFirmType, visibleFirmId, contactId) =>
              this.handleNewPractitionerSuccess(visibleFirmType, visibleFirmId, contactId)
            }
            onCancel={() => this.cancelPractitionerModal()}
          />
        )}

        {this.shouldShowOrgContactModal() && (
          <IcfOrgContactModal
            firmId={this.state.referralOrgId}
            onSuccess={(contactId) => this.handleNewOrgContactSuccess(contactId)}
            onCancel={() => this.cancelContactModal()}
          />
        )}

        {this.shouldShowUnaffilContactModal() && (
          <IcfUnaffiliatedContactModal
            onSuccess={(contactId) => this.handleNewUnaffilContactSuccess(contactId)}
            onCancel={() => this.cancelContactModal()}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  knownFirms: state.firmInfo.knownFirms,
});
const actionProducers = {
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(styles)(NewInquiryModal));
